import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import TaskTemplateFactory from "../../Entity/Factories/TaskTemplateFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { TaskTemplateInterface } from "../../Entity/Entities/Task/TaskTemplateInterface";

export default function* taskTemplateUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_TASK_TEMPLATE_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_TASK_TEMPLATE_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `task-templates/${action.payload?.id}`, {
        name: action.payload?.name,
        details: action.payload?.details,
        executorId: action.payload?.executorId,
        daysToExecute: action.payload?.daysToExecute,
        activityTemplateId: action.payload?.activityTemplateId
    });

    const taskTemplate: TaskTemplateInterface = TaskTemplateFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_TASK_TEMPLATE_UPDATE_SUCCESS,
      payload: {
        taskTemplate: taskTemplate
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, taskTemplate);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_TASK_TEMPLATE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchTaskTemplateUpdate() {
  yield takeEvery(Constants.GLOBAL_TASK_TEMPLATE_UPDATE_START, taskTemplateUpdate);
}
